import Store from '@/store'
import { mapState } from 'vuex'

export default {
  props: ['organizationId', 'programId'],
  data: () => ({
    realOrganizationId: null,
  }),
  computed: mapState({
    program: (state) => state.organizationProgramDetails.program,
  }),
  async created() {
    this.realOrganizationId = this.organizationId
    if (!this.realOrganizationId) {
      const user = await this.$store.dispatch('user/getUser')
      this.realOrganizationId = user.organizationId
      console.log(
        ' => OrganizationIdMixin.realOrganizationId: ',
        this.realOrganizationId,
      )
    }
    this.$store.dispatch('organizationDetails/fetch', {
      id: this.realOrganizationId,
    })
    this.$store.commit('organizationProgramDetails/CLEAN')
    const req = this.$store.dispatch('organizationProgramDetails/getProgram', {
      organizationId: this.realOrganizationId,
      programId: this.programId,
    })
    if (this.onProgramFetchDidStart) {
      this.onProgramFetchDidStart()
    }
    await req
    if (this.onProgramFetchDidFinish) {
      this.onProgramFetchDidFinish()
    }
  },
}
